import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import CallToAction from '../components/CallToAction';
import Engagement from '../components/Engagement';
import Sponsorship from '../components/Sponsorship';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import useSEO from '../hooks/useSEO';

function HomePage() {
  useSEO({
    title: "Accueil | Excellence Éducative & Formation Professionnelle",
    description: "Bienvenue sur le site officiel du Groupe Scolaire et Universitaire Les Palmiers à Togba (Abomey-Calavi, Bénin). Enseignement Général, Technique, Professionnel et Supérieur. 1er Lycée d'Abomey-Calavi.",
    keywords: "GSU Les Palmiers, Lycée Les Palmiers Togba, école Abomey-Calavi, CPEG, CPET, BAC G2 Bénin, inscriptions 2025-2026",
    canonicalUrl: "https://gsulespalmiers.bj/"
  });

  return (
    <div className="home-page">
      <Header />
      <Hero />
      <Stats />
      <CallToAction />
      <Engagement />
      <Sponsorship />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default HomePage;
